import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import Home from '@/pages/Home';
import Playlist from '@/pages/Playlist';
import Resetpass from '@/pages/Resetpass';
import Setpass from '@/pages/Setpass';
import NotFound from '@/pages/NotFound';
import Live from '@/pages/Live';
import feature from '@/feature';

Vue.use(Router);

const requireLogout = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    next({ name: 'home' });
  } else {
    next();
  }
};

const requireLogin = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    next();
  } else {
    store.dispatch('openLoginModal');
    next({ name: 'home' });
  }
};

const requirePysio = (to, from, next) => {
  if (!store.getters.isLoggedIn) {
    store.dispatch('openLoginModal');
    return next({ name: 'home' });
  }

  if (store.getters.isPhysio) {
    return next();
  }

  return next({ name: 'home' });
};

const physioFeature = [
  {
    path: '/physio',
    name: 'physio',
    //meta: { footer: 'physio' },
    component: () => import('@/pages/physio/landing'),
    beforeEnter: requirePysio,
  },
  {
    path: '/physio/patient/:requestId',
    name: 'physio_requestDetailView',
    //meta: { footer: 'physio' },
    component: () => import('@/pages/physio/request'),
    beforeEnter: requirePysio,
  },
  /*{
    path: '/physio/programms',
    name: 'physioProgramms',
    meta: { footer: 'physio' },
    component: () => import('@/pages/physio/Programms'),
    beforeEnter: requirePysio,
  },*/
  {
    path: '/physio/patient/:requestId/programm/new',
    name: 'physio_newProgramm',
    //meta: { footer: 'physio' },
    component: () => import('@/pages/physio/programm'),
    beforeEnter: requirePysio,
  },
  {
    path: '/physio/patient/:requestId/programm/:programmId',
    name: 'physio_programm',
    //meta: { footer: 'physio' },
    component: () => import('@/pages/physio/programm'),
    beforeEnter: requirePysio,
  } /*
  {
    path: '/programm/:id',
    name: 'programm',
    component: () => import('@/pages/physio/Programm'),
  },*/,
  {
    path: '/programm/:id',
    name: 'programm',
    component: () => import('@/pages/Programm'),
  },
  ,
];

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/live',
      name: 'live',
      component: Live,
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/pages/about'),
    },
    {
      path: '/legal/:version?',
      name: 'legal',
      component: () => import('@/pages/legal'),
    },
    {
      path: '/playlist/:id',
      name: 'playlist',
      component: Playlist,
    },
    {
      path: '/glad',
      name: 'glad-signup',
      component: () => import('@/pages/glad/Signup'),
      beforeEnter: requireLogout,
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('@/pages/Signup'),
      beforeEnter: requireLogout,
    },
    {
      path: '/profile/:tabIndex',
      name: 'profile_index',
      component: () => import('@/pages/profile'),
      beforeEnter: requireLogin,
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/pages/profile'),
      beforeEnter: requireLogin,
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: Resetpass,
    },
    {
      path: '/reset-password/:uid/:token',
      name: 'set-password',
      component: Setpass,
    },
    {
      path: '/404',
      name: '404',
      component: NotFound,
    },
    {
      path: '*',
      name: 'not_found',
      component: NotFound,
    },
  ]
    .concat(feature.isVisible('physio') ? physioFeature : [])
    .concat(
      feature.isVisible('faq')
        ? {
            path: '/faq',
            name: 'faq',
            component: () => import('@/pages/faq'),
          }
        : []
    ),
  mode: 'history',
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js